import React from 'react';
import { Heart, Building2, Rocket, Landmark } from 'lucide-react';

export const ENTITY_TYPES = [
  {
    value: 'charity',
    label: 'Charity / Non-Profit',
    icon: Heart,
    description: 'Charities, CIOs and non-profits. Uses Charities Acts, the Charity Governance Code and Charity Commission guidance.',
  },
  {
    value: 'limited_company',
    label: 'Limited Company',
    icon: Building2,
    description: 'Private limited companies. Uses the Companies Act 2006, directors\u2019 duties and the Wates Principles.',
  },
  {
    value: 'startup',
    label: 'Startup',
    icon: Rocket,
    description: 'Early-stage and scaling companies. Uses founder and investor-readiness governance frameworks.',
  },
  {
    value: 'plc',
    label: 'PLC',
    icon: Landmark,
    description: 'Listed and public limited companies. Uses the UK Corporate Governance Code, FCA Listing Rules and DTRs.',
  },
];

const OrganisationTypePicker = ({ value, onChange, columns = 2 }) => {
  return (
    <div className={`grid gap-4 ${columns === 2 ? 'sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-4'}`}>
      {ENTITY_TYPES.map((t) => {
        const Icon = t.icon;
        const selected = value === t.value;
        return (
          <button
            type="button"
            key={t.value}
            onClick={() => onChange(t.value)}
            className={`text-left p-4 rounded-xl transition-all ${
              selected
                ? 'border-2 border-lime bg-lime/10 shadow-saas'
                : 'border border-ink/10 bg-white shadow-saas-sm hover:border-ink/20'
            }`}
          >
            <div className="flex items-center gap-3 mb-2">
              <div className="w-10 h-10 flex items-center justify-center bg-white border border-ink/10 rounded-lg flex-shrink-0">
                <Icon size={20} />
              </div>
              <span className="font-bold tracking-tight text-lg leading-tight">{t.label}</span>
            </div>
            <p className="text-sm font-medium text-ink/70">{t.description}</p>
          </button>
        );
      })}
    </div>
  );
};

export default OrganisationTypePicker;
